module.exports = __webpack_public_path__ + "static/media/03_tn.6c7f35e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/03_tn.jpg
// module id = 492
// module chunks = 0